window.addEventListener('turbolinks:load' , function() {
  const form = document.getElementById('js-debug-form');
  if (form) {
    form.querySelector("select").addEventListener('change', (e) => {
      form.submit();
    });
  }
});
